import { render, staticRenderFns } from "./diagnoseSummary.vue?vue&type=template&id=aab9d8c4&scoped=true&"
import script from "./diagnoseSummary.vue?vue&type=script&lang=js&"
export * from "./diagnoseSummary.vue?vue&type=script&lang=js&"
import style0 from "./diagnoseSummary.vue?vue&type=style&index=0&id=aab9d8c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aab9d8c4",
  null
  
)

export default component.exports